import List from '@utils/list'
import http from '@plugin/axios'
import Select from '@utils/common/select'

const { Search, Table, Operation } = List
// 列表接口
function api(data: any) {
  const params = {
    ...data,
    condition: {
      ...data.condition
    }
  }
  return http({
    url: '/examineProcess/getProcessPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}

const search = new Search('performanceAppraisal.performanceAppraisal.search')
  .placeholder('placeholder')
  .add('purchaseUnitNos').select(Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1', accessControlFlag: 'N' })).attrs({ multiple: true })
  .add('examineStartTime').merge('date')
  .add('examineEndTime').merge('date')
  .add('addbyName')

const table = new Table('performanceAppraisal.performanceAppraisal.table')
  .type('index')
  .add('processNo')
  .add('purchaseUnitName')
  .add('assessSystemName')
  .add('examineProcessPeriod')
  .add('examineYear')
  .add('examineQuarter')
  .add('examineMonth')
  .add('addByName')

// 查看结果
function lookResult(this: any, row: any) {
  const routeParams: any = {
    processNo: row.processNo,
    judgeType: row.judgeType,
    assessSystemName: row.assessSystemName,
    assessSystemNo: row.assessSystemNo,
    purchaseUnitName: row.purchaseUnitName,
    purchaseUnitNo: row.purchaseUnitNo,
    workingPeriodName: row.workingPeriodName,
    workingDateName: row.workingDateName
  }
  this.$router.push({ name: 'Supplier.PerformanceAppraisal.PerformanceAppraisal.ViewResult', params: routeParams })
}

const operation = new Operation('performanceAppraisal.performanceAppraisal')
  .width(250)
  .add('lookResult').handle(lookResult)

export default new List()
  .name('Supplier.PerformanceAppraisal.PerformanceAppraisal')
  .operation(operation)
  .api(api)
  .search(search)
  .table(table)
  .end()
